import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImageBox from '@fingo/lib/components/boxes/ProgressiveImageBox';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

const CredentialProviderAuthMethodSelector = ({
  selectedProvider,
  onCancelHandler,
  onClickHandler,
}) => (
  <Stack spacing={3} alignItems="center" mx={{ sx: 0, md: 8 }}>
    <ProgressiveImageBox src={selectedProvider?.iconUrl} alt={selectedProvider?.name} />
    <Button
      onClick={onCancelHandler}
      variant="text"
      size="small"
      sx={{ textDecoration: 'underline' }}
    >
      ¿No es tu facturador? Selecciona aquí el tuyo
    </Button>
    <Stack direction="row" spacing={1.5}>
      <Button
        variant="hoverHighlightButton"
        sx={{ color: 'text.primary' }}
        onClick={() => onClickHandler('certificate')}
      >
        Ingresa con tu certificado digital
      </Button>
      <Button
        variant="hoverHighlightButton"
        sx={{ color: 'text.primary' }}
        onClick={() => onClickHandler('username')}
      >
        Ingresa con tus credenciales del facturador
      </Button>
    </Stack>
  </Stack>
);

CredentialProviderAuthMethodSelector.propTypes = {
  selectedProvider: PropTypes.shape({
    name: PropTypes.string,
    iconUrl: PropTypes.string,
  }),
  onCancelHandler: PropTypes.func.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

CredentialProviderAuthMethodSelector.defaultProps = {
  selectedProvider: null,
};

export default CredentialProviderAuthMethodSelector;
